import { datadogRum } from '@datadog/browser-rum'
import { fptiCustomEvent } from './fpti'

const eventName = 'DATADOG RUM initialization failed'

export const loadDataDogRumInfo = (dataDogConfig) => {
  try {
    const { encryptedAccountNumber, country } = dataDogConfig.appData
    delete dataDogConfig.appData
    datadogRum.init(dataDogConfig)
    datadogRum.setUser({ id: encryptedAccountNumber, country })
    datadogRum.setGlobalContextProperty('user_country', country)
  } catch (error) {
    fptiCustomEvent(eventName, {
      event_name: eventName,
      error_message: error.message,
    })
  }
}
